// client/src/components/HomePage.js
import React from 'react';
import UnderConstruction from '../../common/UnderConstruction.js'; // Import

function HomePage() {

  return (
    <UnderConstruction/>
  );
}

export default HomePage;